import { render, staticRenderFns } from "./EditAssessment.vue?vue&type=template&id=8fa9874a&scoped=true"
import script from "./EditAssessment.vue?vue&type=script&lang=ts"
export * from "./EditAssessment.vue?vue&type=script&lang=ts"
import style0 from "./EditAssessment.vue?vue&type=style&index=0&id=8fa9874a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa9874a",
  null
  
)

export default component.exports